<template >
 <v-dialog v-model="show_dialog" :max-width="width">
  <v-card>
    <v-card-title>
    	<h2>提现记录</h2>
    </v-card-title>
    <v-card-text>
      
      <v-form>
          <v-text-field
            label="提取金额"
            v-model="money"
            :error = "parseFloat(money)!=money"
            required></v-text-field>
          <v-select
            v-bind:items="sysuser"
            :error = "!who"
            v-model="who"
            label="提取人"
            item-value="_id"
            item-text="name"
            no-data-text="无可选择的人员"
            required
            clearable
          ></v-select>
          <v-select
            v-model="bywho"
            :error = "!bywho"
            v-bind:items="sysuser"
            label="经手人"
            item-value="_id"
            item-text="name"
            no-data-text="无可选择的人员"
            required
            clearable
          ></v-select>
      </v-form>
    </v-card-text>
    
    <v-card-actions>
    	<v-spacer></v-spacer>
      <v-btn class="btn-" @click.stop="init_value();show_dialog=false">取消</v-btn>
      <v-btn
	      :loading="creating"
	      :disabled="creating||!(money*1&&who&&bywho)"
	      color="info"
	      @click.native.stop="create_record">
	      确定
	      <span slot="loader" class="custom-loader">
	        Loading...
	      </span>
	  </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>       
        
   
</template>

<script>
import * as CashApi from "@/api/module/shop_cash"	
import {selectoption} from "@/api/module/select_options"	
export default {
    //template:``,
    name: '',
    props:{
    	width:{
    		type:String,
    		default:'500px'
    	}
    },
    computed:{
    	show_dialog:{
	      get(){
	          return this.$store.state.dialog.show_take_cash_dialog;
	      },
	      set(val){
	          this.$store.commit('SHOW_DIALOG_TAKE_CASH',val)
	      }
	    }
    },
    methods:{
    	init_value(){
    		this.money  = this.who = this.bywho = null;
    	},
    	get_user_list(){
    		console.log("NEED GET SYSUSER LIST");
    		selectoption({oper:'sysuser',key:"_id",value:"name",type:'obj'}).then(resp=>{
    			this.sysuser= resp.data;
    		}).catch(err=>{
    			console.log(err);
    		})
    	},
    	create_record(){
    		console.log("click")
    		this.creating = true;

    		if(1*this.money && this.who && this.bywho){
    			CashApi.create_cash_withdraw({data:{
					money :this.money,
					who   :this.who,
					bywho :this.bywho,
					order_id:this.order_id
    			}}).then(doc=>{
    				this.$notify({
				        group: 'msg',
				        type: 'success',
				        title: '操作成功！',
				        text: '提现记录创建成功',
				        duration: 500,
				    })
				    this.show_dialog = false;
				    this.init_value();
    			}).catch(err=>{
    				this.$notify({
				        group: 'msg',
				        type: 'warn',
				        title: '操作失败！',
				        text: '提现记录创建失败'+err.message
				    })
    			}).then(_=>{
    				this.creating = false;
    			})
    		}
    	}
    },
    components:{},
    watch:{
    	show_dialog(val){
    		if(val){
    			this.order_id = + new Date();
    			
    			if(this.sysuser.length == 0){
    				this.get_user_list();
    			}
    		}
    	}
    },
    directives: {},
    mounted :function(){
    	if(this.sysuser.length == 0){
    		this.get_user_list()
    	}
    },
    data () {
      return {
      	creating:false,
		money :null,
		who   :null,
		bywho :null,
		order_id:+ new Date(),
		sysuser:[],
      }
    },
    filters: {
      //pluralize: (n, w) => n === 1 ? w : (w + 's'),
      capitalize: s => s.charAt(0).toUpperCase() + s.slice(1)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/front_sale/dialogs/dialog_take_money.vue